import { t } from "@web-monorepo/i18n/macro";
import { DDSButton, DDSHeadlineText, DDSTextField } from "@web-monorepo/dds";
import { IconCheck } from "@web-monorepo/dds-icons";
import React from "react";
import { Student } from "src/pods/students";
import filterByName from "src/utils/filterByName";
import styles from "./SelectStudents.module.css";

type SelectStudentsProps = {
  onChange: (students: Student[]) => void;
  students: Student[];
};

type SelectStudentsState = {
  filteredStudents: Student[] | null;
  selectedStudents: Student[];
};

const initialState: SelectStudentsState = {
  filteredStudents: null,
  selectedStudents: [],
};

// eslint-disable-next-line react-prefer-function-component/react-prefer-function-component
export default class SelectStudents extends React.Component<SelectStudentsProps, SelectStudentsState> {
  constructor(props: SelectStudentsProps) {
    super(props);
    this.state = initialState;
  }

  render() {
    const { students } = this.props;
    const { filteredStudents, selectedStudents } = this.state;

    function renderStudent(this: SelectStudents, student: Student) {
      const isSelected = selectedStudents.includes(student);
      return (
        <li className={styles.listItem} key={student._id}>
          <DDSButton
            variant="unstyled"
            data-name="select_students:render_student:img"
            className={styles.studentRow}
            onClick={() => this.toggleStudent(student)}
            aria-pressed={isSelected}
          >
            <img className={styles.avatar} src={student.avatar} alt="" />
            <DDSHeadlineText as="h2" level="md" className={styles.name}>
              {student.firstName} {student.lastName.slice(0, 1)}.
            </DDSHeadlineText>
            <div className={`${styles.checkmark} ${isSelected ? styles.checked : styles.unchecked}`}>
              <IconCheck className={styles.checkmarkIcon} />
            </div>
          </DDSButton>
        </li>
      );
    }

    return (
      <section className={styles.section}>
        <div className={styles.searchField}>
          <DDSTextField
            data-name="select_students:search"
            ariaLabel={t`Type or select name`}
            placeholder={t`Type or select name`}
            onChange={this.filterStudents}
          />
        </div>
        <ul className={styles.list} aria-live="polite">
          {students && (filteredStudents || students).map(renderStudent, this)}
        </ul>
      </section>
    );
  }

  toggleStudent = (student: Student) => {
    let { selectedStudents } = this.state;
    if (selectedStudents.includes(student)) {
      selectedStudents = selectedStudents.filter((s) => s !== student);
    } else {
      selectedStudents = [...selectedStudents, student];
    }
    this.setState({ selectedStudents }, () => this.props.onChange(selectedStudents));
  };

  filterStudents = (value: string) => {
    const { students } = this.props;
    this.setState({
      filteredStudents: value ? filterByName(students, value) : null,
    });
  };
}
